import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=2f5878e0"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=2f5878e0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5878e0')) {
      api.createRecord('2f5878e0', component.options)
    } else {
      api.reload('2f5878e0', component.options)
    }
    module.hot.accept("./ClientsTable.vue?vue&type=template&id=2f5878e0", function () {
      api.rerender('2f5878e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientsTable.vue"
export default component.exports